// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"f65be896","608":"0fac2d3c","931":"d6d68eeb"}[chunkId] + ".chunk.css";
};